import React from 'react';

import positions from '../../../images/positions.svg';

import { FOHImage } from '../../ingredients';

export const FOHToolBoxIcon = (props: any) => (
  <FOHImage
    source={{ uri: positions }}
    style={
      props && !!props.style
        ? { width: 20, height: 20, ...props.style }
        : { width: 20, height: 20 }
    }
  />
);
